// extracted by mini-css-extract-plugin
export default {"menu":"SidebarMenu_menu__CcEVW","menuItem":"SidebarMenu_menuItem__tbzqV","activeMenuItem":"SidebarMenu_activeMenuItem__31NTa","menuItemText":"SidebarMenu_menuItemText__TQhjO"};